/**
 * AppShell — the authenticated admin frame: auth gate, the sidebar, and
 * the routed page beside it (DESIGN-SYSTEM.md, Admin global navigation).
 *
 * Mounted once as a react-router layout route, so the sidebar survives
 * navigation and `RequireAuth` is declared in one place instead of per-route.
 *
 * The sidebar changes with the page rather than sitting apart from it: its
 * head is the one search and the way into Settings, then the places, and
 * while Settings is open it *is* Settings' section list, with the way back
 * at its top. Settings keeps it at full width wherever there is a sidebar
 * at all (md up), since its sections have names and no icons. Below md
 * there is no sidebar: the places, the search and Settings are a tab bar
 * along the foot (`TabBar`), as a phone's own apps keep them.
 */
import { Outlet, useLocation } from "react-router";
import { RequireAuth } from "../../lib/auth";
import { isSettings, useRememberPlace } from "../../lib/last-place";
import { PHONE_WIDTH, useMedia } from "../../lib/use-media";
import { AppNav } from "./AppNav";
import { TabBar } from "./TabBar";
import styles from "./AppShell.module.css";

export function AppShell() {
  const { pathname } = useLocation();
  const phone = useMedia(PHONE_WIDTH);
  useRememberPlace();
  return (
    <RequireAuth>
      <div className={styles.shell}>
        <aside
          className={
            isSettings(pathname) ? styles.sidebarSettings : styles.sidebar
          }
        >
          <AppNav />
        </aside>
        <main className={styles.main}>
          <Outlet />
        </main>
        {phone && <TabBar />}
      </div>
    </RequireAuth>
  );
}
